import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import { GlobalVariables } from '../../../globalVar';
import {
  Autocomplete,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import { getToast } from '../../../utils/toastConfig';

function ModalCUpdate(props) {
  const {
    saveChangesString,
    clientInfoBNameString,
    clientMCCompanyNameString,
    notesString,
  } = useTranslationHook();

  var businessNameDefaultU = localStorage.getItem('businessNameForUpdate');
  var clientRFCDefaultU = localStorage.getItem('rfcForUpdate');
  var companyNameDefaultU = localStorage.getItem('companyNameForUpdate');
  var clientNotesDefaultU = localStorage.getItem('clientNotesForUpdate');
  var selectedRegionDefaultU = localStorage.getItem('selectedRegionForUpdate');

  const [business, setBusiness] = useState(businessNameDefaultU);
  const [rfc, setRFC] = useState(clientRFCDefaultU);
  const [companyName, setCompanyName] = useState(companyNameDefaultU);
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notes, setNotes] = useState(clientNotesDefaultU);

  useEffect(() => {
    if (props.show) {
      fetchRegions();
    }
  }, [props.show]);

  const fetchRegions = async () => {
    customAxios
      .get(`${GlobalVariables.getURL()}region/`, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        setRegions(response.data.data);
        const matchingRegion = response.data.data.find(
          (region) => region.id === parseInt(selectedRegionDefaultU)
        );
        setSelectedRegion(matchingRegion || null);
      })
      .catch((error) => console.log(error));
  };

  const resetFormFields = () => {
    setBusiness(localStorage.getItem('businessNameForUpdate'));
    setRFC(localStorage.getItem('rfcForUpdate'));
    setCompanyName(localStorage.getItem('companyNameForUpdate'));
    setNotes(localStorage.getItem('clientNotesForUpdate'));
    setSelectedRegion(null);
  };

  function hide() {
    resetFormFields();
    props.onHide();
    getToast({
      status: 'success',
      title: 'Plaza actualizada exitosamente en la base de datos.',
    });
    props.getClients();
  }

  function updateClient(event) {
    event.preventDefault();
    setIsLoading(true);
    var updateClientId = localStorage.getItem('client_id');
    const updateData = {
      business_name: business,
      rfc: rfc,
      company_name: companyName,
      region_id: selectedRegion?.id,
      notes,
    };

    customAxios
      .patch(
        `${GlobalVariables.getURL()}updateClient/${updateClientId}`,
        updateData,
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      )
      .then(
        (response) => {
          hide();
        },
        (error) => {
          console.log(error);
          if (error.response.data === 'Cliente ya existe.') {
            getToast({
              status: 'error',
              title:
                'Ya existe una Plaza con esta información. Vuelve a intentarlo.',
            });
          } else {
            getToast({
              status: 'error',
              title: 'Error al actualizar Plaza. Vuelve a intentarlo.',
            });
          }
        }
      )
      .finally(() => setIsLoading(false));
  }

  return (
    <Modal
      onEntering={resetFormFields}
      onHide={() => {
        resetFormFields();
        props.onHide();
      }}
      {...props}
      size="lg"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar Plaza</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="update-client-form" onSubmit={updateClient}>
          <div className="row">
            <div className="col-md-12">
              <TextField
                fullWidth
                required
                label={clientInfoBNameString}
                type="text"
                value={business}
                onChange={(e) => setBusiness(e.target.value)}
              />
            </div>
            {/* <div className='col-md-6'>
              <TextField
                sx={{ width: '100%' }}
                label='RFC'
                type='text'
                value={rfc}
                onChange={(e) => setRFC(e.target.value)}
              />
            </div> */}
          </div>
          <br />

          <div className="row">
            {/* <div className='col-md-6'>
              <TextField
                sx={{ width: '100%' }}
                label={clientMCCompanyNameString}
                type='text'
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
            </div> */}
            <div className="col-md-12">
              <Autocomplete
                options={regions}
                value={selectedRegion}
                getOptionLabel={(i) => i.name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(_, newValue) => {
                  setSelectedRegion(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    disabled={isLoading}
                    required
                    {...params}
                    label={'Región'}
                    placeholder={'Región...'}
                  />
                )}
              />
            </div>
          </div>

          {/* <br /> */}

          {/* <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={notesString}
                type='text'
                value={notes !== 'null' ? notes : ''}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div> */}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="submit"
          form="update-client-form"
          className="save-modal-button"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size="2rem" />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCUpdate;
